module.exports = __webpack_public_path__ + "static/media/creditcard-normal.33cc2303.png";